import React from 'react';
import Icon from '../../../components/AppIcon';
import { IntegrationProcess as IntegrationProcessType } from '../types';

const IntegrationProcess: React.FC = () => {
  const processSteps: IntegrationProcessType[] = [
    {
      id: '1',
      step: 1,
      title: 'Discovery & Analysis',
      description: 'Comprehensive audit of your existing systems, data flows, and integration requirements. We map your entire tech stack and identify optimization opportunities.',
      icon: 'Search',
      duration: '1-2 weeks'
    },
    {
      id: '2',
      step: 2,
      title: 'Architecture Design',
      description: 'Custom integration architecture blueprint with detailed technical specifications, security protocols, and scalability planning.',
      icon: 'Layout',
      duration: '1-2 weeks'
    },
    {
      id: '3',
      step: 3,
      title: 'Development & Testing',
      description: 'Agile development with continuous integration, comprehensive unit testing, and security vulnerability assessments.',
      icon: 'Code2',
      duration: '3-6 weeks'
    },
    {
      id: '4',
      step: 4,
      title: 'Deployment & Migration',
      description: 'Phased rollout with zero-downtime deployment, data migration validation, and rollback procedures.',
      icon: 'Rocket',
      duration: '1-2 weeks'
    },
    {
      id: '5',
      step: 5,
      title: 'Monitoring & Optimization',
      description: 'Continuous performance monitoring, proactive issue resolution, and ongoing optimization based on usage patterns.',
      icon: 'Activity',
      duration: 'Ongoing'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            Our Integration Process
          </h2>
          <p className="text-lg text-text-secondary">
            A proven methodology that ensures successful integration every time
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-border transform -translate-x-1/2"></div>
            
            {processSteps.map((step, index) => (
              <div 
                key={step.id}
                className={`relative mb-12 lg:mb-16 ${
                  index % 2 === 0 ? 'lg:pr-1/2' : 'lg:pl-1/2 lg:text-right'
                }`}
              >
                <div className={`lg:w-1/2 ${index % 2 === 0 ? 'lg:pr-12' : 'lg:pl-12'}`}>
                  <div className="bg-card p-6 rounded-lg border border-border hover:shadow-lg transition-all duration-fast">
                    <div className={`flex items-center space-x-4 mb-4 ${
                      index % 2 === 0 ? '' : 'lg:flex-row-reverse lg:space-x-reverse'
                    }`}>
                      <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                        <Icon name={step.icon} size={24} className="text-white" />
                      </div>
                      <div className="flex-1">
                        <div className="text-sm font-medium text-primary mb-1">
                          Step {step.step} • {step.duration}
                        </div>
                        <h3 className="text-xl font-semibold text-text-primary">
                          {step.title}
                        </h3>
                      </div>
                    </div>
                    <p className="text-text-secondary leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
                
                <div className="hidden lg:block absolute left-1/2 top-6 w-4 h-4 bg-primary rounded-full transform -translate-x-1/2 border-4 border-background"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationProcess;